import React from "react";

const partners = [
  "onecupB.png",
  "jurucoffee.png",
  "ikawahouse.png",
  "ikawacafe.png",
  "monacoffee.png",
];

const Partners = () => {
  return (
    <section className="bg-cream-warm py-14">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <p className="mb-2 text-center text-[11px] font-semibold uppercase tracking-[0.24em] text-gold">
          Trusted by Cafés Across Rwanda
        </p>
        <h2 className="mb-10 text-center font-display text-2xl text-espresso md:text-3xl">
          As Featured With
        </h2>
        <div className="grid grid-cols-2 items-center gap-8 sm:grid-cols-3 lg:grid-cols-5">
          {partners.map((image) => (
            <div key={image} className="flex items-center justify-center">
              <img
                src={`/${image}`}
                alt="Partner logo"
                className="h-14 w-auto object-contain opacity-80 transition hover:opacity-100 md:h-16"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Partners;
